import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';
import { subscriptionEventSourceLabelKey } from '../utils/eventLabels';

interface SubscriptionEventSourceBadgeProps {
  eventSource: string;
  className?: string;
}

export function SubscriptionEventSourceBadge({
  eventSource,
  className,
}: SubscriptionEventSourceBadgeProps) {
  const { t } = useTranslation();
  const label = t(subscriptionEventSourceLabelKey(eventSource), { defaultValue: eventSource });

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 whitespace-nowrap',
        className,
      )}
    >
      {label}
    </span>
  );
}
